import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import AdAccountModel from '../model/AdAccountModel';

type AccountResponse = {
  adAccount: AdAccountModel;
};

type AccountsResponse = {
  data: AdAccountModel[];
  next: string;
};

type AssignAdAccountResponse = {
  errors: string[];
  success: boolean;
};

export default class AdAccountController extends AuthenticatedController {
  static retrieve(adAccountId: string): Promise<AccountResponse> {
    return super.get(APIRoutes.REMOTE_AD_ACCOUNT(adAccountId));
  }

  static retrieveAll(
    fbPageId: number | undefined,
    extended: boolean = false,
    next: string = '',
    all: boolean = false,
  ): Promise<AccountsResponse> {
    return super.get(
      APIRoutes.REMOTE_AD_ACCOUNTS(
        fbPageId,
        extended,
        all,
        encodeURIComponent(next),
      ),
    );
  }

  static retrieveByFbPageId(fbPageId: number): Promise<AdAccountModel> {
    return super.get(APIRoutes.FB_PAGE_AD_ACCOUNTS(fbPageId));
  }

  static assignAdAccount(
    facebookPageId: number,
    adAccount: AdAccountModel,
    selected: boolean,
  ): Promise<AssignAdAccountResponse> {
    return super.post(APIRoutes.ASSIGN_AD_ACCOUNT_TO_FB_PAGE, {
      facebookPageId,
      remoteId: adAccount.id,
      userId: adAccount.userId,
      selected,
      name: adAccount.name,
    });
  }
}
